import React from "react";
import { GrPowerCycle } from "react-icons/gr";


export const LoadingScreen = () => {
    return (
        <div>
            <p className="z-10 animate-spin">
                {" "}
                <GrPowerCycle size="26" />
            </p>
            {/* You can add additional loading screen content or styles here */}
        </div>
    );
};

